// Mock Data for HK Altbausanierung Website
// DSGVO-konform: Alle Bilder lokal gehostet, keine externen Requests

export const companyInfo = {
  name: "HK Altbausanierung",
  tagline: "Ihr vertrauensvoller Partner für erstklassige Altbausanierung",
  founded: 2012,
  teamSize: 6,
  experience: 13,
  address: "Gartenstraße 16, 73061 Ebersbach an der Fils",
  phone: "0172 9308274",
  phoneLandline: "07163 5357890",
  email: "hk-altbausanierung@outlook.de",
  socialMedia: {
    instagram: "https://www.instagram.com/hkaltbausanierung?igsh=eXo4cjZsbGp5OWM=",
    facebook: "https://www.facebook.com/share/17kKy6zktx/"
  }
};

// Lokale Bilder - keine externen Requests zu Unsplash/Pexels
export const heroImages = [
  "/images/hero-1.jpg",
  "/images/hero-2.jpg",
  "/images/hero-3.jpg"
];

export const teamImage = "/images/team.jpg";

export const services = [
  {
    id: 1,
    title: "Fassadensanierung",
    description: "Professionelle Restaurierung und Modernisierung historischer Fassaden mit hochwertigen Materialien und traditioneller Handwerkskunst.",
    image: "/images/service-fassade.jpg",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Dachsanierung",
    description: "Komplette Dachsanierung und -restaurierung unter Berücksichtigung moderner Energiestandards und fachgerechter Ausführung.",
    image: "/images/service-dach.jpg",
    icon: "Home"
  },
  {
    id: 3,
    title: "Innensanierung",
    description: "Umfassende Modernisierung von Innenräumen mit Erhalt historischer Elemente und Integration moderner Haustechnik.",
    image: "/images/service-innen.jpg",
    icon: "PaintBucket"
  },
  {
    id: 4,
    title: "Energetische Sanierung",
    description: "Energieeffiziente Modernisierung unter Wahrung der Gebäudesubstanz für nachhaltigen Werterhalt.",
    image: "/images/service-energie.jpg",
    icon: "Zap"
  }
];

export const projects = [
  {
    id: 1,
    title: "Historisches Stadthaus Stuttgart",
    description: "Komplette Sanierung eines denkmalgeschützten Gebäudes aus dem 19. Jahrhundert",
    image: "/images/project-1.jpg",
    year: 2023
  },
  {
    id: 2,
    title: "Altbau-Villa Degerloch",
    description: "Fassadensanierung und energetische Modernisierung",
    image: "/images/project-villa.jpg",
    year: 2023
  },
  {
    id: 3,
    title: "Gründerzeit-Ensemble",
    description: "Restaurierung mehrerer Fassaden im historischen Kern",
    image: "/images/project-gruenderzeit.jpg",
    year: 2022
  },
  {
    id: 4,
    title: "Historisches Fachwerkhaus",
    description: "Behutsame Sanierung mit hochwertiger Ausführung",
    image: "/images/project-4.jpg",
    year: 2022
  },
  {
    id: 5,
    title: "Altbau-Mehrfamilienhaus",
    description: "Umfassende Modernisierung bei laufendem Betrieb",
    image: "/images/project-mehrfamilienhaus.jpg",
    year: 2021
  },
  {
    id: 6,
    title: "Historisches Handelshaus",
    description: "Fassadenrestaurierung und Innensanierung",
    image: "/images/project-handelshaus.jpg",
    year: 2021
  }
];

export const aboutFeatures = [
  {
    icon: "CheckCircle2",
    title: "Zuverlässigkeit",
    description: "Termingerechte Umsetzung und verlässliche Projektabwicklung"
  },
  {
    icon: "Target",
    title: "Präzision",
    description: "Höchste handwerkliche Qualität bis ins kleinste Detail"
  },
  {
    icon: "Settings",
    title: "Moderne Technik",
    description: "Innovative Verfahren kombiniert mit traditionellem Handwerk"
  },
  {
    icon: "Users",
    title: "Persönliche Betreuung",
    description: "Individuelle Beratung und enger Austausch während des gesamten Projekts"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Wie lange dauert eine typische Altbausanierung?",
    answer: "Die Dauer hängt stark vom Umfang des Projekts ab. Eine Fassadensanierung dauert in der Regel 4-8 Wochen, während umfassende Sanierungen 3-12 Monate in Anspruch nehmen können. Wir erstellen für jedes Projekt einen detaillierten Zeitplan."
  },
  {
    id: 2,
    question: "Welche Garantien bieten Sie auf Ihre Arbeiten?",
    answer: "Wir bieten eine umfassende Gewährleistung nach VOB/BGB. Die genauen Garantiezeiten hängen von den durchgeführten Arbeiten ab und werden vertraglich festgehalten. Für Materialien gelten die Herstellergarantien."
  },
  {
    id: 3,
    question: "Kann ich während der Sanierung im Haus wohnen bleiben?",
    answer: "Das hängt vom Umfang der Arbeiten ab. Bei reinen Fassadensanierungen ist ein Verbleib meist möglich. Bei Innensanierungen planen wir die Arbeiten oft abschnittsweise, um die Beeinträchtigung zu minimieren. Wir besprechen dies individuell mit Ihnen."
  },
  {
    id: 4,
    question: "Übernehmen Sie auch die Planung und Genehmigungen?",
    answer: "Ja, wir bieten einen Komplettservice von der Planung über die Genehmigungen bis zur Ausführung. Wir arbeiten mit erfahrenen Architekten und Ingenieuren zusammen und kümmern uns um alle behördlichen Abstimmungen."
  },
  {
    id: 5,
    question: "In welchem Umkreis sind Sie tätig?",
    answer: "Unser Haupteinsatzgebiet ist Stuttgart und Umgebung (ca. 50 km Radius). Für größere Projekte sind wir auch überregional in Baden-Württemberg tätig. Sprechen Sie uns gerne an!"
  }
];
